<template>
  <div class="c-app">
    <div class="p-4">
      <div class="row">
        <div id="btn-return" class="d-flex justify-content-end pt-1 mt-2">
          <div class="btn-home h-100">
            <button
              type="button"
              class="btn btn-outline-main bg-main text-white"
              @click="mtdHc"
            >
              <i class="fas fa-regular fa-notes-medical"></i><br />Agregar N° de
              HC
            </button>
          </div>
          &nbsp;
          <div class="btn-home h-100">
            <button
              type="button"
              class="btn btn-outline-main bg-main text-white"
              @click="mtdBackCampus"
            >
              <i class="fas fa-recycle"></i><br />Cambiar de Sede
            </button>
          </div>
          &nbsp;
          <div class="btn-home h-100">
            <button
              type="button"
              class="btn btn-bm-noradius h-100"
              @click="mtdCloseBead"
            >
              <i class="fas fa-cash-register"></i><br />Cerrar
            </button>
          </div>
        </div>
      </div>
      <!-- Venta -->
      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12">
          <div class="text-center p-4">
            <div
              class="d-grid gap-2 mx-auto col-lg-3 col-md-3 col-sm-12 col-xs-12"
            >
              <button
                class="btn btn-lg btn-bm mt-100"
                @click="generarVenta"
                type="button"
              >
                VENTA
              </button>
              <button
                class="btn btn-lg btn-bm"
                @click="generarEgreso"
                type="button"
              >
                EGRESO
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-12 col-sm-6">
          <div class="row p-1">
            <div class="col-md-12 col-lg-8 col-xl-6 px-sm-2 px-md-4">
              <div class="row d-flex">
                <div id="btn_refresh" class="col-md-12">
                  <button type="button" @click="mtdCleanClient" class="btn">
                    <i class="fa fa-repeat"></i>
                  </button>
                </div>
                <div class="col-md-3 p-2 mt-200">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    @keypress="isNumber($event)"
                    v-model="client.document"
                    @keypress.enter="mtdSearchDocument"
                    maxlength="12"
                    placeholder="Documento"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-9 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-model="client.fullName"
                    :disabled="disabledPatient"
                    placeholder="Nombres y apellidos del paciente"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-3 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-on:keypress="isNumber($event)"
                    v-model="client.celphone"
                    maxlength="9"
                    placeholder="Teléfono"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-9 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-model="client.email"
                    placeholder="Correo del paciente"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-3 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-on:keypress="isNumber($event)"
                    @keyup="mtdVerifEdad"
                    v-model="client.yearOld"
                    maxlength="3"
                    placeholder="Edad"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-9 p-2 d-flex align-items-center justify-content-center">
                  <div class="sex-toggle">
                    <label
                      class="sex-toggle__option"
                      :class="{ 'sex-toggle__option--active': client.sex_type == 1 }"
                      for="femenino"
                    >
                      <input
                        type="radio"
                        id="femenino"
                        :value="1"
                        v-model="client.sex_type"
                      />
                      <i class="fas fa-venus"></i>
                      <span>Femenino</span>
                    </label>

                    <label
                      class="sex-toggle__option"
                      :class="{ 'sex-toggle__option--active': client.sex_type == 2 }"
                      for="masculino"
                    >
                      <input
                        type="radio"
                        id="masculino"
                        :value="2"
                        v-model="client.sex_type"
                      />
                      <i class="fas fa-mars"></i>
                      <span>Masculino</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6 p-2">
                  <button
                    :class="
                      client.type == 'particular'
                        ? 'form-control form-control-lg inpunt-rounded bg-main text-white'
                        : 'form-control form-control-lg inpunt-rounded'
                    "
                    @click="mtdSelectType('particular')"
                    type="button"
                    aria-label=".form-control-lg example"
                  >
                    Particular
                  </button>
                </div>
                <div class="col-md-6 p-2">
                  <button
                    :class="
                      client.type == 'eps'
                        ? 'form-control form-control-lg inpunt-rounded bg-main text-white'
                        : 'form-control form-control-lg inpunt-rounded'
                    "
                    @click="mtdSelectType('eps')"
                    type="button"
                    aria-label=".form-control-lg example"
                  >
                    Eps
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4"></div>
            <div
              class="col-md-6 mt-2 px-sm-2 px-md-4"
              v-if="client.type == 'eps'"
            >
              <div class="eps-chip-list">
                <span
                  v-for="(item, index) in insurances"
                  :key="index"
                  class="eps-chip"
                  :class="{ 'eps-chip--active': client.insurance == item.id }"
                  @click="mtdSelectEps(item.id)"
                >
                  <i
                    v-if="client.insurance == item.id"
                    class="fas fa-check eps-chip__icon"
                  ></i>
                  {{ item.name }}
                </span>
              </div>
            </div>
            <div class="col-md-6 mx-2" v-if="client.type == 'eps'">
              <div id="list-eps" class="d-flex justify-content-evenly">
                <input
                  type="text"
                  class="form-control form-control-sm w-25 inpunt-rounded"
                  placeholder="Costo fijo"
                  v-model="client.fijo"
                  v-on:keypress="isNumber($event)"
                />
                <input
                  type="text"
                  class="form-control form-control-sm w-25 inpunt-rounded"
                  placeholder="% CUBRE EPS"
                  v-model="client.copago"
                  v-on:keypress="isNumber($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
  name: "c-Admision-home",
  props: {
    verifBead: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SweetAlert,
  },
  data() {
    return {
      page: null,
      disabledPatient: true,
      swal: null,
      client: {
        document: "",
        celphone: "",
        email: "",
        fullName: "",
        yearOld: "",
        sex_type: null,
        type: "",
        insurance: null,
        copago: "",
        fijo: "",
      },
      insurances: [],
    };
  },
  created() {
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdGetData: function () {
      this.get({
        url: this.$store.getters.get__url + "/Admision/listInsurances",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.insurances = response.data;
        })
        .catch(() => {});
    },
    mtdSearchDocument: function () {
      let length = this.client.document.length;

      if (length < 8) {
        this.$refs.SweetAlert.showWarning(
          "Debe ingresar 8 dígitos cómo mínimo"
        );
        return;
      }

      switch (length) {
        case 8:
          this.mtdSendRequestForDni(); //Enviar petición para DNI - 8 Dígitos
          break;
        case 9:
          this.mtdSendRequestForCE(); //Enviar para CE - 9 Dígitos
          break;
        default:
          this.disabledPatient = false;
          this.client.celphone = "";
          this.client.email = "";
          this.client.fullName = "";
          this.client.yearOld = "";
          this.client.sex_type = "";
          break;
      }
    },
    mtdSendRequestForDni() {
      this.get({
        url: `${this.$store.getters.get__url}/reniec/${this.client.document}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.boo == 3) {
            this.$refs.SweetAlert.showWarning("DNI no encontrado");
            this.disabledPatient = false;
            this.client.fullName = "";
          } else {
            this.client.fullName = `${response.data.name} ${response.data.last_name}`;
            if (response.data.hasOwnProperty("patient")) {
              this.client.celphone = response.data.patient.phone;
              this.client.email = response.data.patient.email;
              this.client.yearOld = response.data.patient.year;
              this.client.sex_type = response.data.patient.sex_type;
            } else {
              this.client.celphone = "";
              this.client.email = "";
              this.client.yearOld = "";
              this.client.sex_type = "";
              this.disabledPatient = true;
            }
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdSendRequestForCE() {
      this.get({
        url: `${this.$store.getters.get__url}/cee/${this.client.document}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode != 200) {
            this.$refs.SweetAlert.showWarning(
              "Número de documento no encontrado"
            );
            this.disabledPatient = false;
            this.client.fullName = "";
            this.client.celphone = "";
            this.client.email = "";
            this.client.yearOld = "";

            return;
          }

          let patient = response.data.patient;

          this.client.fullName = patient.name;
          this.client.celphone = patient.phone ?? "";
          this.client.email = patient.email ?? "";
          this.client.yearOld = patient.year ?? "";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mtdSelectType: function (type) {
      this.client.type = type;
    },
    mtdSelectEps: function (id) {
      this.client.insurance = id;
    },
    mtdCleanClient: function () {
      this.disabledPatient = true;
      this.client = {
        document: "",
        celphone: "",
        email: "",
        fullName: "",
        yearOld: "",
        type: "",
        sex_type: null,
        insurance: null,
        copago: "",
        fijo: "",
      };
    },
    mtdVerifClient() {
      const { client } = this;

      if (!client.document.trim())
        return { msg: "Ingrese datos del cliente.", status: false };

      if (!client.yearOld || !client.yearOld.trim())
        return { msg: "Ingrese edad.", status: false };
      
      if (!client.sex_type)
        return { msg: "Seleccione el sexo.", status: false };
      
      if (!client.type.trim()) return { msg: "Escoja un tipo.", status: false };

      if (client.type == "eps" && !client.insurance) {
        return { msg: "Escoja un seguro Eps.", status: false };
      }

      return { msg: "Cliente válido.", status: true };
    },

    generarVenta: function () {
      let clientValid = this.mtdVerifClient();

      if (clientValid.status) {
        this.$emit("mtdChangePage", "venta", this.client);
      } else {
        this.$refs.SweetAlert.showWarning(clientValid.msg);
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode != 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    generarEgreso() {
      this.$emit("mtdChangePage", "egreso", this.client);
    },
    otrasViews() {
      this.$emit("mtdChangePage", "laboratorio"); // Cambiar por views: 'imagenes', 'topico', 'laboratorio'
    },
    mtdVerifEdad: function () {
      if (!this.client.yearOld || this.client.yearOld.length <= 0) {
        return;
      }

      if (this.client.yearOld > 110) {
        this.client.yearOld = "";
        this.$refs.SweetAlert.showWarning("Edad incorrecta");
      }
    },
    mtdCloseBead() {
      this.$emit("mtdChangePage", "close");
    },
    mtdHc() {
      this.$emit("mtdChangePage", "Hc");
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
  },
};
</script>

<style scoped>
.sex-toggle {
  display: inline-flex;
  border: 1px solid #dcdce0;
  border-radius: 50px;
  overflow: hidden;
  background-color: #f5f5f7;
}

.sex-toggle__option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  margin: 0;
  cursor: pointer;
  font-weight: 500;
  color: #8a8a97;
  transition: background-color 0.15s ease, color 0.15s ease;
  user-select: none;
}

.sex-toggle__option input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.sex-toggle__option i {
  font-size: 0.9rem;
}

.sex-toggle__option--active {
  background-color: #900052;
  color: #fff;
}

.sex-toggle__option:not(.sex-toggle__option--active):hover {
  background-color: #eceef1;
}

.eps-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.eps-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 50px;
  border: 1px solid #eb5077;
  color: #eb5077;
  background-color: #fff;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.1s ease;
  user-select: none;
}

.eps-chip:hover {
  background-color: #fdeef1;
}

.eps-chip:active {
  transform: scale(0.97);
}

.eps-chip--active {
  background-color: #900052;
  border-color: #900052;
  color: #fff;
}

.eps-chip--active:hover {
  background-color: #900052;
}

.eps-chip__icon {
  font-size: 0.75rem;
}
</style>
